import { doc, getDoc } from 'firebase/firestore';
import { db } from './firebase';

export interface HQPartnerSettings {
  logoUrl?: string;
  email?: string;
  phone?: string;
  name: string;
  website?: string;
  address?: string;
}

export interface Partner {
  id: string;
  name: string;
  displayName?: string;
  email?: string;
  phone?: string;
  website?: string;
  address?: string;
  logoUrl?: string;
  description?: string;
  contactPerson?: string;
}

/**
 * Fetch HQ partner settings from Firestore
 * HQ partner ID is 'propinvest_hq'
 */
export async function getHQPartnerSettings(): Promise<HQPartnerSettings | null> {
  try {
    const partnerRef = doc(db, 'partners', 'propinvest_hq');
    const partnerSnap = await getDoc(partnerRef);

    if (partnerSnap.exists()) {
      const data = partnerSnap.data();
      return {
        logoUrl: data.branding?.logoUrl,
        email: data.settings?.emailFromEmail || 'info@propinvest.co.za',
        phone: data.settings?.phone || '+27 12 345 6789',
        name: data.displayName || data.name || 'PropInvest\u2122',
        website: data.branding?.website,
        address: data.settings?.address
      };
    }

    // Fallback if partner not found
    return {
      name: 'PropInvest\u2122',
      email: 'info@propinvest.co.za',
      phone: '+27 12 345 6789'
    };
  } catch (error) {
    console.error('Error fetching HQ partner settings:', error);
    return {
      name: 'PropInvest\u2122',
      email: 'info@propinvest.co.za',
      phone: '+27 12 345 6789'
    };
  }
}

/**
 * Fetch a partner by ID
 */
export async function getPartnerById(partnerId: string): Promise<Partner | null> {
  try {
    const partnerRef = doc(db, 'partners', partnerId);
    const partnerSnap = await getDoc(partnerRef);

    if (partnerSnap.exists()) {
      const data = partnerSnap.data();
      return {
        id: partnerSnap.id,
        name: data.name || data.displayName || 'Partner',
        displayName: data.displayName || data.name,
        email: data.settings?.emailFromEmail || data.email,
        phone: data.settings?.phone || data.phone,
        website: data.branding?.website || data.website,
        address: data.settings?.address || data.address,
        logoUrl: data.branding?.logoUrl || data.logoUrl,
        description: data.description,
        contactPerson: data.contactPerson
      };
    }

    return null;
  } catch (error) {
    console.error('Error fetching partner:', error);
    return null;
  }
}
